export function generateColumns<T, K extends keyof T>(keysEnum: T) {
	return Object.keys(keysEnum).map((key) => ({
		name: key as K,
	}));
}
